import * as React from "react";
import SvgIcon from "@material-ui/core/SvgIcon";

const SvgI24Publish = props => {
  return (
    <SvgIcon {...props}>
      <path d="M2 3V10L17 12L2 14V21L23 12L2 3ZM4 6.03L11.53 9.25L4 8.25V6.03ZM11.53 14.75L4 17.97V15.75L11.53 14.75Z" />
    </SvgIcon>
  );
};

export default SvgI24Publish;
